import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import { osPlatform } from "../../store/GlobalVarriables";
import { getQueryParam } from "../../utils/helpers";

import { ReactComponent as CellsIcon } from "../../static/images/cells.svg";
import { ReactComponent as CalendarIcon } from "../../static/images/calendar.svg";
import { ReactComponent as ClockIcon } from "../../static/images/sand_clock.svg";
import { ReactComponent as GroupIcon } from "../../static/images/group.svg";
import { ReactComponent as FinanceIcon } from "../../static/images/finance.svg";
import { ReactComponent as CustomersIcon } from "../../static/images/customers_nav_icon.svg";

import "./style.scss";

const Footer = () => {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isIOS = osPlatform === "iOS";
  const isFirstTime = Boolean(getQueryParam("firstTime", location));

  const getUserRole = () => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
    if (ps10005000) {
      const encodedToken = jwtDecode(ps10005000);
      return encodedToken.roles;
    }
  };

  return (
    <footer className="footer-container">
      {(pathname === "/schedules" && isFirstTime) ||
      pathname === "/invite" ||
      !localStorage.ps10005000 ? null : (
        <nav className="nav-container">
          <div className={`links-wrapper ${isIOS ? "ios" : ""}`}>
            <NavLink
              className={`nav-link`}
              to={getUserRole() === "Consumer" ? "/clubs" : "/customers"}
            >
              {getUserRole() === "Consumer" ? (
                <>
                  <CellsIcon className="icon" />

                  <span>{t("market")}</span>
                </>
              ) : (
                <>
                  <CustomersIcon className="icon" />
                  <span>{t("customers")}</span>
                </>
              )}
            </NavLink>
            {getUserRole() === "Provider" ? (
              <NavLink className={`nav-link`} to={"/schedules"}>
                <GroupIcon className="icon" />
                <span>{t("classes")}</span>
              </NavLink>
            ) : (
              <NavLink className={`nav-link`} to={"/my-classes"}>
                <GroupIcon className="icon" />
                <span>{t("classes")}</span>
              </NavLink>
            )}

            <NavLink to="/sessions" className="nav-link sessions">
              <CalendarIcon className="icon" />
              <span>{t("sessions")}</span>
            </NavLink>
            <NavLink
              className="nav-link history"
              to={
                getUserRole() === "Consumer"
                  ? "/history"
                  : "/history/byschedule"
              }
            >
              {getUserRole() === "Provider" ? (
                <>
                  <ClockIcon className="icon" />
                  <span>{t("history")}</span>
                </>
              ) : (
                <>
                  <ClockIcon className="icon" />
                  <span>{t("history")}</span>
                </>
              )}
            </NavLink>

            <NavLink
              className="nav-link"
              to={getUserRole() === "Consumer" ? "/bills" : "/finances"}
            >
              {getUserRole() === "Consumer" ? (
                <>
                  <FinanceIcon className="icon" />
                  <span>{t("bills")}</span>
                </>
              ) : (
                <>
                  <FinanceIcon className="icon" />
                  <span>{t("finance")}</span>
                </>
              )}
            </NavLink>
          </div>
        </nav>
      )}
      {/* <div className="skedy-rights">
        <p>{t("skedy_rights", { year: new Date().getFullYear() })}</p>
      </div> */}
    </footer>
  );
};

export default Footer;
